export const reportSelections = [
    { name: "Batch History", link: "/merchant/reports/batch", type: "Merchants" },
    { name: "Sales by Merchant", link: "/admin/reports/sales-by-merchant", type: "Admin" },
    { name: "Point Transfers", link: "/admin/reports/point-tranfers", type: "Admin" }
]